<template>
  <b-card no-body class="border-0 shadow p-2 mb-4">
    <b-card-header header-tag="header" class="p-0 border-0" role="tab">
      <h5 class="p-2">
        <i class="fa fa-list-ol" />
        NIVELES DE UBICACIÓN
      </h5>
    </b-card-header>
    <b-card-body class="py-3 px-0">
      <b-row>
        <b-col sm="8">
          <b-form-group>
            <b-input-group>
              <b-form-input
                name="nombre"
                type="text"
                placeholder="Buscar..."
                v-model="filtro_niveles.description"
                class="text-uppercase"
                @keypress.enter="listLevels"
              />
              <b-input-group-append>
                <!-- <b-button variant="primary" @click.prevent="listLevels">
                  <i class="fa fa-search fa-lg" />
                  <span class="d-none d-md-inline-block">Buscar</span>
                </b-button> -->
                <b-button @click="limpiarNiveles" class="btn btn-default">
                  <i class="fa fa-eraser fa-lg" />
                  <span class="d-none d-md-inline-block"> Limpiar</span>
                </b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>

        <b-col sm="4">
          <b-button
            v-if="validarPermisoComponente('empresa-editar-ubicaciones')"
            variant="primary"
            class="float-right"
            @click="mostrarModalNiveles('Crear')"
          >
            Crear nuevo nivel
          </b-button>
        </b-col>
      </b-row>

      <b-row>
        <b-col sm="12">
          <b-table
            responsive
            striped
            hover
            small
            :items="niveles"
            :fields="columnas"
            thead-tr-class="table-active"
            class="mb-0"
            empty-text="No hay niveles para mostrar"
            show-empty
          >

            <template class="text-center" v-slot:cell(color)="data">
              <div class="data-color"
                  :style="[{ 'background-color': data.item.color }]">
              </div>
            </template>


            <template v-slot:cell(estado)="data">
              <b-badge
                v-if="data.item.active"
                variant="primary"
                v-text="'Activa'"
              />
              <b-badge v-else variant="danger" v-text="'Inactiva'" />
            </template>

            <template v-slot:cell(actions)="data">
            <el-tooltip content="Editar"  placement="bottom" effect="light">
                <a
                class="botonProduct text-dark mr-3"
                @click="editarNivel(data.item)"
              >
                <i class="fa fa-edit"></i>
              </a>
              </el-tooltip>


                <el-tooltip :content="!!data.item.active ? 'Inactivar' : 'Activar'"  placement="bottom" effect="light">
                <a
                class="botonProduct"
                @click="eliminarNivel(data.item)"
              >
                <i class="fa fa-close text-danger" v-if="!!data.item.active" />
                <i class="fa fa-check text-success" v-else />
              </a>
              </el-tooltip>

            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-card-body>

    <b-modal
      v-model="modal_niveles.ver"
      :title="accion_niveles + ' nivel'"
      hide-footer
      size="lg"
    >
      <form @submit.prevent="validarFormularioNiveles" data-vv-scope="niveles">
        <b-row>
          <b-col sm="6">
            <b-form-group>
              <label for="description">Descripción</label>
              <b-form-input
                type="text"
                id="description"
                name="description"
                data-vv-as=" "
                class="text-uppercase"
                v-validate="'required|min:3|max:30'"
                v-model="selectedNivel.description"
              />
              <span class="text-danger span-error small">{{
                errors.first("niveles.description")
              }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group>
              <label for="level">Nivel de Ubicación</label>
              <b-form-input
                type="number"
                id="level"
                name="level"
                data-vv-as=" "
                class="text-uppercase"
                v-validate="'required'"
                v-model="selectedNivel.level"
              />
              <span class="text-danger span-error small">{{
                errors.first("niveles.level")
              }}</span>
            </b-form-group>
          </b-col>
          <b-col sm="6">
            <b-form-group label="Color">
              <b-form-input v-model="selectedNivel.color" type="color" id="color" name="color" list="color-options">
              </b-form-input>
              <datalist id="color-options">
                <option v-for="color in colorOptions">{{  color }}</option>
              </datalist>
            </b-form-group>
          </b-col>
          <!-- switch the use_for_dashboard value 0 or 1 -->
            <b-col sm="6">
                <b-form-group>
                <label for="use_for_dashboard">
                    Usar en Dashboard
                </label>
                <b-form-checkbox
                    id="use_for_dashboard"
                    name="use_for_dashboard"
                    v-model="selectedNivel.use_for_dashboard"
                    switch
                    :value="1"
                    :unchecked-value="0"
                >
                    <template #default>
                    <span class="text-uppercase">
                        {{ selectedNivel.use_for_dashboard ? "Si" : "No" }}
                    </span>
                    </template>
                </b-form-checkbox>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
          <b-col class="">
            <hr />
            <b-button
              @click="validarFormularioNiveles"
              size="sm"
              variant="primary"
              class="mr-2"
            >
              <i class="fa fa-floppy-o fa-lg"></i> Guardar
            </b-button>
            <b-button size="sm" class="btn btn-default" @click="closedModal"
              ><i class="fa fa-times-circle fa-lg" aria-hidden="true"></i>
              Cancelar</b-button
            >
          </b-col>
        </b-row>
      </form>
    </b-modal>
  </b-card>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { validarPermisoComponente } from "@/plugins/acl";

export default {
  name: "niveles",
  data() {
    return {
      colorOptions: ['#FCE4EC', '#BBDEFB', '#F0F4C3','#FFF59D', '#e6e6fa', '#ffdab9', '#EEEEEE', '#C5CAE9', '#7fffd4', '#FFCC80'],
      validarPermisoComponente: validarPermisoComponente,
    };
  },
  computed: {
    ...mapState("location", [
      "selectedNivel",
      "niveles",
      "nivelesActivos",
      "id_ubicacion",
      "filtro_niveles",
      "modal_niveles",
      "accion_niveles",
    ]),
    columnas(){
        const columnasBase = [
            {
                key: "level",
                label: "Nivel",
                sortable: true,
                tdClass: "text-center",
                thClass: "text-center",
                thStyle: "width: 80px; max-width:80px",
            },
            {
                key: "description",
                label: "Descripción",
                tdClass: "text-uppercase",
                sortable: true,
            },
            {
                key: "color",
                label: "Color",
                tdClass: "text-uppercase",
                sortable: true,
            },
            {
                key: "created_at",
                label: "Fecha_de_creación",
                tdClass: "text-uppercase",
                sortable: true,
            },
            {
                key: "estado",
                label: "Estado",
                sortable: true,
                tdClass: "text-center",
                thClass: "text-center",
                thStyle: "width: 120px; max-width:120px",
            },
        ];

        if(this.validarPermisoComponente('empresa-editar-ubicaciones')){
            columnasBase.push({
                key: "actions",
                label: "Opciones",
                tdClass: "text-center",
                thClass: "text-center",
                thStyle: "width: 120px; max-width:120px",
            });
        }

        return columnasBase;
    }
  },
  methods: {
    ...mapActions("location", [
      "crearNivel",
      "listLevels",
      "updateNivel",
      "deleteNivel",
      "listarNivelActivos",
      "arbolUbicacionesEmpresa"
    ]),
    ...mapMutations("location", [
      "setSelectedNivel",
      "resetFiltroNiveles",
      "establecerModalNiveles",
      "establecerAccionNiveles",
      "resetSelectedNivel",
      "resetFiltroNiveles",
    ]),
    async limpiarNiveles() {
      this.resetFiltroNiveles();
      await this.listLevels();
    },
    mostrarModalNiveles(accion) {
      this.resetSelectedNivel();
      this.establecerAccionNiveles(accion);
      this.establecerModalNiveles(true);
    },
    async editarNivel(nivel) {
      this.mostrarModalNiveles("Actualizar");
      this.setSelectedNivel(nivel);
    },
    closedModal() {
      this.resetSelectedNivel();
      this.establecerModalNiveles(false);
    },
      async validarFormularioNiveles() {
          await this.$validator.validateAll("niveles").then(async (validado) => {
              if (validado) {
                  if (this.selectedNivel.use_for_dashboard) {
                      return new Promise((resolve) => {
                          this.$alertConfirmation({
                              icon: "warning",
                              title: "Advertencia nivel marcado para Dashboard",
                              text: `Al activar esta opción, este nivel será visible en el dashboard de la empresa, además si tenia un nivel anteriormente marcado para dashboard, este se desmarcará, ¿Desea continuar?`,
                              showConfirmButton: true,
                              showCancelButton: true,
                              confirmButtonText: this.accion_niveles === "Crear" ? "Continuar" : "Actualizar",
                              cancelButtonText: "Cancelar",
                              onConfirm: async () => {
                                  resolve(true);
                              },
                              onCancel: async () => {
                                  resolve(false);
                              },
                          });
                      }).then(async (result) => {
                          if (result) {
                              if (this.accion_niveles === "Crear") {
                                  await this.crearNivel(this.$route.params.id).then(async () => {
                                      await this.arbolUbicacionesEmpresa();
                                  });
                              } else {
                                  await this.updateNivel(this.selectedNivel.id).then(async () => {
                                      await this.arbolUbicacionesEmpresa();
                                  });
                              }
                          }
                      });
                  }else{
                      if (this.accion_niveles === "Crear") {
                          await this.crearNivel(this.$route.params.id).then(async () => {
                              await this.arbolUbicacionesEmpresa();
                          });
                      } else {
                          await this.updateNivel(this.selectedNivel.id).then(async () => {
                              await this.arbolUbicacionesEmpresa();
                          });
                      }
                  }


              }
          });
      },
    async eliminarNivel(nivel) {
      this.setSelectedNivel(nivel);
      await this.deleteNivel(this.selectedNivel.id);
      this.resetSelectedNivel();
    },
  },
};
</script>

<style scoped>

.data-color {
  border-radius: 1px;
  width: 50px;
  height: 25px;
}

</style>
